
import { Vue, Prop, Watch, Component } from "vue-property-decorator";
import { ControladorInterfaz } from "../../../../controlador";
import { Pedido } from "@/__env/lib/Ventas/Pedidos";
import { Factura } from "@/__env/lib/CuentasCorrientes/Facturas";
import { Utiles } from "@/__env/pluggins/event-bus";
import { WebCam } from "vue-web-cam";
@Component({
  name: "Componente",
  props: {},
  components: {
    "vue-web-cam": WebCam
  }
})
export default class Componente extends Vue {
  mounted() {}

  isCameraOpen = false;
  isPhotoTaken = false;
  isShotPhoto = false;
  isLoading = false;
  selectedCamera: InputDeviceInfo = null;
  pictures: string[] = [];
  get SelectedCamera() {
    return this.selectedCamera;
  }
  set SelectedCamera(camera: InputDeviceInfo) {
    this.setCamera(camera);
  }
  Cameras: InputDeviceInfo[] = [];

  get WebCam() {
    return this.$refs.webCam as any;
  }

  setCamera(camera: InputDeviceInfo) {
    console.log(camera);

    if (camera && this.selectedCamera !== camera) {
      this.selectedCamera = camera;
      this.WebCam.changeCamera(this.selectedCamera.deviceId);
    }
    this.WebCam.start();
  }

  onCameras(cameras: any[]) {
    this.Cameras.push(...(cameras as any));
    this.setCamera(this.Cameras[0]);
  }

  capture() {
    const pic = this.WebCam.capture();
    this.pictures.push(pic);
  }

  delPicture(pic: string) {
    const idx = this.pictures.findIndex(x => x == pic);
    if (idx > -1) {
      this.pictures.splice(idx, 1);
    }
  }

  onError(...error: any[]) {
    console.log(error);
  }
}
